// export const getJobInputs = createSelector(
//   getResultSettings,
//   getSettingsState,
//   getJobSettingsState,
//   (result, settings, jobSettings, hanger, joist, truss, multiTruss) => {
//     const connectionType = settings.connectionType
//     const configuration = jobSettings.configuration
//     const member = {
//       joist,
//       truss,
//       multiTruss:
//         {
//           leftCenter: { leftHip: multiTruss.leftHip, jack: multiTruss.jack },
//           leftRight: { leftHip: multiTruss.leftHip, rightHip: multiTruss.rightHip },
//           centerRight: { jack: multiTruss.jack, rightHip: multiTruss.rightHip },
//         }[configuration] ?? multiTruss,
//     }
//     return Object.assign(
//       {},
//       { settings, jobSettings, result },
//       connectionType !== 'multiTruss' && { hanger },
//       member[connectionType],
//     )
//   },
// )

import { createSelector } from '@reduxjs/toolkit'
import {
  getGirderState,
  getHeaderState,
  getJackState,
  getJoistState,
  getLeftHipState,
  getRightHipState,
  getTrussState,
} from './slices'

export * from './slices/form/selectors'
export * from './slices/girder/selectors'
export * from './slices/hanger/selectors'
export * from './slices/header/selectors'
export * from './slices/jack/selectors'
export * from './slices/jobSettings/selectors'
export * from './slices/jobTally/selectors'
export * from './slices/joist/selectors'
export * from './slices/leftHip/selectors'
export * from './slices/result/selectors'
export * from './slices/rightHip/selectors'
export * from './slices/settings/selectors'
export * from './slices/truss/selectors'
export * from './slices/ui/selectors'

export const selectMembersState = createSelector(
  getHeaderState,
  getJoistState,
  getGirderState,
  getTrussState,
  getJackState,
  getLeftHipState,
  getRightHipState,
  (header, joist, girder, truss, jack, leftHip, rightHip) => ({
    header,
    joist,
    girder,
    truss,
    jack,
    leftHip,
    rightHip,
  }),
)
